import { Middleware } from '@nuxt/types'
import { OwnerDetailActions, OwnerDetailGetters } from '~/store/owner/detail'
import { ActiveUserActions } from '~/store/user/active'
import { User } from '~/types/types'

const passList = ['login', 'signup', 'github', 'bitbucket', 'gitlab']

/**
 * Middleware to block routes for non-beta users
 * ! note: returns early for onPrem users
 */
const betaUserMiddleware: Middleware = async ({ store, route, error, $config }) => {
  if ($config.onPrem) {
    return
  }

  // Check passlist
  if (route.name && passList.includes(route.name)) {
    return
  }

  // Check for team beta
  const checkForTeamBeta = route.meta?.some((meta: { checkOwnerBeta?: boolean }) => {
    return Boolean(meta?.checkOwnerBeta)
  })

  const { provider, owner: login } = route.params

  if (checkForTeamBeta && login && provider) {
    await store.dispatch(`owner/detail/${OwnerDetailActions.FETCH_OWNER_DETAILS}`, {
      provider,
      login
    })
    const isOwnerBetaTester = store.getters[`owner/detail/${OwnerDetailGetters.IS_BETA_TESTER}`]
    if (!isOwnerBetaTester) error({ statusCode: 404 })

    return
  }

  await store.dispatch(`user/active/${ActiveUserActions.FETCH_VIEWER_INFO}`)
  const viewer = store.state.user.active.viewer as User

  if (!viewer.isBetaTester) error({ statusCode: 404 })
}

export default betaUserMiddleware
